










































import { Vue, Prop, Component } from "vue-property-decorator";
import { FileItem as IFileItem } from "@/api/models/file-item";

@Component
export default class UserAvatar extends Vue {
  @Prop() url?: URL;
  @Prop() file?: IFileItem;
  @Prop({ default: "alt" }) alt?: string;
  @Prop({ default: false }) isShowCloseButton?: boolean;
  @Prop({ default: false }) isShowSelectFileButton?: boolean;
  @Prop({ default: false }) notShowEmpty?: boolean;
}
